import { API } from '@Providers';

export default async function () {
  const endpoint = '/api/shelter/forms/get-outcome-forms/';

  return API({ endpoint });
}
